import axios from "axios";
import { API_HOST } from "@/core/variables";

class PermissionRepository {
    find = async (agentId: number) => {
        return axios.get(`${API_HOST}/v1/agents/${agentId}/permission`);
    };
}

const permissionRepository = new PermissionRepository();

export default permissionRepository;